export type PurchaseStatus = 'full' | 'partial' | null

interface PurchasableItem {
  adet?: number | null
  satin_alindi_mi?: boolean | null
  satin_alinan_adet?: number | null
}

// Sınıf listesindeki ürünlerin (tekstilde aynı modelin tüm bedenlerinin) bu sezon satın alınan adedini listedeki
// adetle karşılaştırır: karşılandıysa 'full' (Satın Alındı), kısmen karşılandıysa 'partial' (Kısmen Satın Alındı),
// hiç alınmadıysa null.
export const getPurchaseStatus = (items: ReadonlyArray<PurchasableItem>): PurchaseStatus => {
  const bought = items.filter((item) => item.satin_alindi_mi)
  if (bought.length === 0) return null
  // API adet bilgisini henüz göndermiyorsa (eski sürüm) önceki davranış: alınmış sayılır.
  if (bought.every((item) => item.satin_alinan_adet === undefined || item.satin_alinan_adet === null)) return 'full'

  const purchased = bought.reduce((sum, item) => sum + (item.satin_alinan_adet ?? 0), 0)
  const required = Math.max(1, ...items.map((item) => item.adet ?? 1))
  return purchased >= required ? 'full' : 'partial'
}
